<template>
    <div id="app_p">
        <div class="phone_web">
            <div class="header_p">
                <div class="logo_p"><img :src="logo" alt="" style="width:6rem;"></div>
                <div class="menu_p"><img :src="logo_p" alt="" style="width:1.4rem" @click="doMenu()"></div>
            </div>
            <div class="cai_p" style="display:none" v-click-outside="outsideClick">

                <div class="close_p"><img src="./assets/images/zimi-logo-b.png" alt=""  style="width:6rem"><img src="./assets/images/phone/close.png" alt=""  style="width:1.4rem;float: right;" @click="doClose()"></div>
                <div class="indexNav_p">
                    <ul class="navLi_p">
                        <li v-for="(item,index) of list" :key="index" :class="{active: isActive === index}"  @click="changeClass(index)">
                            <div style="width:.2rem;height:.9rem;margin-right:.3rem">
                                <div v-if="index==isActive" style="width: .2rem;height:.9rem;background: #1559B7;margin-right:.3rem"></div>
                            </div>
                            <router-link :to="item.router">{{item.title}}</router-link>
                        </li>
                    </ul>
                </div>

            </div>
             <router-view/>
             <div class="icon-web" style="font-size:.8rem;text-align:center;width: 100%;color:#000">© 深圳市字米网络科技有限公司. All Rights Reserved <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#000"><br>粤ICP备2020115013号 </a><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030702004430" target="_blank" style="color:#000"><img src="./assets/images/guo.png" style="vertical-align: middle;margin-top: -5px;"> 粤公网安备 44030702004430号</a></div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            display: 'block',
            list: [
                {
                    title: '首页',
                    router: '/'
                },
                {
                    title: '字米WMS',
                    router: '/WMS'
                },
                // {
                //     title: '字米TMS',
                //     router: '/TMS'
                // },
                {
                    title: '联系我们',
                    router: '/contactUs'
                },
            ],
            isActive: 0,
            show: 0,
            logo: require('./assets/images/zimi-logo.png'),
            logo_p: require('./assets/images/phone/menu.png')
        }
    },
    created() {
        if(localStorage.getItem('menu')){
            this.show = localStorage.getItem('menu');
            this.isActive = Number(localStorage.getItem('menu'));
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScrolls, true)
    },
    methods: {
        doMenu () {
            if(this.$route.path=='/'){
                this.isActive = 0
            }else if(this.$route.path=='/WMS'){
                this.isActive = 1
            }else if(this.$route.path=='/TMS'){
                this.isActive = 2
            }else{
                this.isActive = 3
            }
            let div = document.getElementsByClassName('cai_p');
            div[0].style.display = 'block';
            this.display = 'none';
        },
        doClose () {
            let div = document.getElementsByClassName('cai_p');
            div[0].style.display = 'none';
        },
        outsideClick() {
            let div = document.getElementsByClassName('cai_p');
            if(this.display=='block'){
                div[0].style.display = 'none';
            }else{
                this.display = 'block';
            }
        },
        handleScrolls(e) {
            let div = document.getElementsByClassName('cai_p');
            if(this.display=='block'){
                div[0].style.display = 'none';
            }
            var scrollTop = e.target.documentElement.scrollTop || e.target.body.scrollTop;
            var home = document.getElementsByClassName('navLi_p');
            var out = document.getElementsByClassName('header_p');
            if(localStorage.getItem('menu')==2&&scrollTop < 10){
                out[0].style = 'background-color:none';
                home[0].classList.add('blank');
                this.logo = require('./assets/images/zimi-logo-b.png');
                this.logo_p = require('./assets/images/phone/menu_p.png')
            }else if(scrollTop > 10) {
                out[0].style = 'background-color:#fff';
                home[0].classList.add('blank');
                this.logo = require('./assets/images/zimi-logo-b.png');
                this.logo_p = require('./assets/images/phone/menu_p.png')
            }else{
                out[0].style = 'background-color:none';
                home[0].classList.remove('blank');
                this.logo = require('./assets/images/zimi-logo.png');
                this.logo_p = require('./assets/images/phone/menu.png')
            }
        },
        changeClass (i) {
            let top = document.documentElement.scrollTop || document.body.scrollTop
            // 实现滚动效果
            document.body.scrollTop = document.documentElement.scrollTop = top = 0
            var home = document.getElementsByClassName('navLi_p');
            var out = document.getElementsByClassName('header_p');
            this.show = i;
            localStorage.setItem('menu',i);
            if(localStorage.getItem('menu')==2){
                home[0].classList.add('blank');
                this.logo = require('./assets/images/zimi-logo-b.png');
                this.logo_p = require('./assets/images/phone/menu_p.png')
            }else{
                out[0].style = 'background-color:none';
                home[0].classList.remove('blank');
                this.logo = require('./assets/images/zimi-logo.png');
                this.logo_p = require('./assets/images/phone/menu.png')
            }
            this.isActive = i;
            let div = document.getElementsByClassName('cai_p');
            div[0].style.display = 'none';
        },
    }
}
</script>
<style scoped>
.phone_web /deep/ .blank li.active a {
    border-bottom: none!important;
}
#app_p {
    width: 100%;
}
a {
    text-decoration: none;
}

.phone_web {
    /* height:1000px; */
}
.header_p {
    /* background:yellow; */
    position: fixed;
    width: 100%;
    display: flex;
    align-items: center;
    z-index: 2;
    /* top:0; */
}
.logo_p {
    padding: 1.2rem  1.6rem;
}
.menu_p {
    text-align: right;
    width: 100%;
}
.menu_p img {
    margin-right: 2rem;
}
.cai_p {
    width: 100%;
    height: 12.3rem;
    background: #fff;
    position: fixed;
    z-index: 4;
}
.close_p {
    /* text-align: right; */
}
.close_p {
    margin-right: 2rem;
    margin-left: 1.6rem;
    margin-top: 1.2rem;
}

.navLi_p li {
    list-style-type:none;
    display: flex;
    align-items: center;
    padding:.6rem 1.8rem;
}
.navLi_p .active a{
    color: #000000!important;
    text-decoration: none!important;
}
.navLi_p a{
    color: #000000!important;
    text-decoration: none!important;
    line-height: 1rem;
    font-size: .9rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #000000;
    width: 100%;
}
.indexNav_p ul {
    padding:0rem;
}
.zimi-title {
    position: absolute;
    /* top: 22.2rem; */
    margin-top: -13rem;
    z-index: 1;
    left: 12.6%;
    text-align: left;
    width: 14rem;
}
.zimi-title1 {
    position: absolute;
    margin: 0auto;
    margin-top: -6.5rem;
    z-index: 1;
    width: 100%;
    text-align: center;
}
.title2 {
    font-size: 1.5rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
    letter-spacing: .2rem;
    padding-bottom: .5rem;
}
.title3 {
    font-size: .9rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0A70EC;
    letter-spacing: .2rem;
}
.title1 {
  font-size: 1.4rem;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 2.2rem;
  letter-spacing: .1rem;
  padding-bottom: .1rem;
}
.decrtion {
  font-size: 1rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 1.7rem;
  letter-spacing: .2rem;
}
</style>



// WEBPACK FOOTER //
// src/App_p.vue